import { AemComponentMap } from "./AemComponents";
import { SsrComponentMap } from "./SsrComponents";
import { bootstrap } from "./tools/bootstrapper";

bootstrap().then(() => {
    window.hydrator.registerComponentMap("AEM", AemComponentMap);
    window.hydrator.registerComponentMap("SSR", SsrComponentMap);
    window.hydrator.rehydrate();
});
